import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M1.244 13.043A19.957 19.957 0 0 0 0 20c0 2.446.44 4.79 1.244 6.956L20 28.696l18.756-1.74A19.956 19.956 0 0 0 40 20c0-2.446-.44-4.79-1.244-6.957L20 11.304l-18.756 1.74Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M20 0C11.4 0 4.07 5.427 1.244 13.043h37.512C35.93 5.428 28.599 0 20 0Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#6DA544",
  d: "M20 40c8.6 0 15.93-5.428 18.756-13.044H1.244C4.07 34.572 11.401 40 20 40Z"
}, null, -1), r = [
  n,
  c,
  s
];
function d(h, i) {
  return e(), l("svg", o, [...r]);
}
const a = { render: d };
export {
  a as default,
  d as render
};
